import SpotHero from 'spothero';
import SHFastClick from 'sh-fastclick';
import Utils from 'utils';

export default {
    init() {
        SpotHero.init();

        if (Utils.isTouchDevice) {
            SHFastClick.init();
        }
    }
};



// WEBPACK FOOTER //
// ./spothero/static/main/js/modules/desktop/desktop.js